module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-7.2e4cd2a7.png";